import { returnToLastUrl, useAppTranslation } from "@/utils";
import { InfoCircleFilled } from "@payping/icons";
import { Button, Flex, Typography } from "@payping/web-components";

interface PlanProps {
  url?: string;
  name?: string;
}
const UnAvailableChoosePlan = (props: PlanProps) => {
  const { t } = useAppTranslation();

  const handleClickButton = () => {
    returnToLastUrl();
  };

  return (
    <Flex vertical className="tw:h-full tw:w-full tw:p-4!">
      <Flex flex={1} vertical justify="center" align="center" gap={"large"}>
        <InfoCircleFilled width={80} className="tw:fill-color-warning" />
        <Flex vertical className="tw:w-full" gap={"small"} align="center">
          <Typography.Title level={5} className="tw:m-0!">
            {t("pay.noPlaneAvailableTitle")}
          </Typography.Title>
          <Typography.Paragraph type="secondary" className="tw:m-0! tw:text-center!">
            {t("pay.noPlaneAvailableContent", { name: props.name ?? t("common.wanted") })}
          </Typography.Paragraph>
        </Flex>
      </Flex>
      <Flex align="center" className="tw:mt-auto tw:w-full" gap={"middle"}>
        {props.url ? (
          <a href={props.url}>
            <Button type="primary" block>
              {props.name ? t("pay.returnTo", { name: props.name }) : t("common.returnToShop")}
            </Button>
          </a>
        ) : (
          <Button
            onClick={() => {
              handleClickButton();
            }}
            type="primary"
            block
          >
            {props.name ? t("pay.returnTo", { name: props.name }) : t("common.returnToShop")}
          </Button>
        )}
      </Flex>
    </Flex>
  );
};

export default UnAvailableChoosePlan;
